module.exports = __webpack_public_path__ + "static/media/check-active.62a1106b.svg";